import React, { useEffect, useState } from 'react'
import { VictoryPie, VictoryContainer } from 'victory'
import Label from "./label";
import styles from '../../ResumenADN.module.css'
import style from './style.module.css'
import { PieChartColors } from './colors'

const formatNum = (num) => {
  return (num).toLocaleString("en-US")
}

const DoughnutChart = ({ data }) => {
  const dataChart = data.resumenADN
  const [showNecesitas, setShowNecesitas] = useState(false)
  const [showTienes, setShowTienes] = useState(false)

  const height = 388
  const width = 461
  const innerRadius = 130
  const radius = 90
  const nameKey = "x"
  const valueKey = "y"
  const have = dataChart[2].operandos[4].monto
  const need = [...dataChart[0].operandos, ...dataChart[1].operandos].reduce((acc, cur) => acc + cur.monto, 0)
  const maxHave = formatNum(Math.round(have))
  const maxNeed = formatNum(Math.round(need))
  const totalPrice = formatNum(Math.round(have + need))

  const dataValues = [
    { x: `$ ${maxNeed}`, y: need, id: 'need' },
    { x: `$ ${maxHave}`, y: have, id: 'have' }
  ]
  const centerX = width / 2;
  const centerY = height / 2;

  const handleChartPress = (e) => {
    if (e === 'have') {
      setShowTienes(true)
      setShowNecesitas(false)
    } else {
      setShowNecesitas(true)
      setShowTienes(false)
    }
  }

  useEffect(() => {
    const elmNeed = document.querySelector("#need")
    const elmHave = document.querySelector("#have")

    elmNeed.addEventListener("click", () => handleChartPress('need'))
    elmHave.addEventListener("click", () => handleChartPress('have'))

    return () => {
      elmNeed.removeEventListener('keydown', handleChartPress);
      elmHave.removeEventListener('keydown', handleChartPress);
    };
  }, [])

  const closeBox = () => {
    setShowNecesitas(false)
    setShowTienes(false)
  }

  return (
    <div className={style.content}>
      <div className={styles.container__wrapper}>
        <div className={style.legend}>
          <div className={style.legend__item}>
            <div className={`${style.legend__item__color} ${style.legend__tienes}`} />
            <div className={style.legend__item__text}>Tienes</div>
          </div>
          <div className={style.legend__item}>
            <div className={`${style.legend__item__color} ${style.legend__necesitas}`} />
            <div className={style.legend__item__text}>Te falta</div>
          </div>
        </div>
      </div>
      <div className={style.content__chart}>
        <div className={style.content__chart__text}>
          <div className={style.content__chart__textNecesitas}>
            Necesitas
          </div>
          $ {totalPrice}
        </div>
        <VictoryPie
          height={height}
          containerComponent={<VictoryContainer className={style.marginPie} responsive={false}/>}
          width={width}
          radius={radius}
          innerRadius={innerRadius}
          padAngle={0}
          cornerRadius={0}
          colorScale={PieChartColors}
          animate={{ duration: 300 }}
          data={dataValues}
          x={nameKey}
          y={valueKey}
          labelComponent={
            <Label
              innerRadius={innerRadius}
              radius={radius}
              nameKey={nameKey}
              valueKey={valueKey}
              cx={centerX}
              cy={centerY}
            />
          }
        />
        {showNecesitas && (
          <div className={style.noteBox}>
            <div className={style.noteBox__close} onClick={closeBox}>x</div>
            <div className={style.noteBox__row}>
              <div className={`${style.noteBox__row__text} ${style.noteBox__row__textMain}`}>
                {dataChart[0].descripcion}
              </div>
              <div className={`${style.noteBox__row__value} ${style.noteBox__row__valueMain}`}>
                $ {formatNum(Math.round(dataChart[0].operandos.reduce((acc, cur) => acc + cur.monto, 0)))}
              </div>
            </div>
            {dataChart[0].operandos.map((e, i) => (
              <div className={style.noteBox__row} key={i}>
                <div className={style.noteBox__row__text}>
                  {e.caption}
                </div>
                <div className={style.noteBox__row__value}>
                  $&nbsp;&nbsp;{formatNum(Math.round(e.monto))}
                </div>
              </div>
            ))}
            <div className={style.noteBox__row} style={{ marginTop: '10px' }}>
              <div className={`${style.noteBox__row__text} ${style.noteBox__row__textMain}`}>
                + {dataChart[1].descripcion}
              </div>
              <div className={`${style.noteBox__row__value} ${style.noteBox__row__valueMain}`}>
                $ {formatNum(Math.round(dataChart[1].operandos.reduce((acc, cur) => acc + cur.monto, 0)))}
              </div>
            </div>
            {dataChart[1].operandos.map((e, i) => (
              <div className={style.noteBox__row} key={i}>
                <div className={style.noteBox__row__text}>
                  {e.caption}
                </div>
                <div className={style.noteBox__row__value}>
                  $ {formatNum(Math.round(e.monto))}
                </div>
              </div>
            ))}
            <div className={style.noteBox__row} style={{ marginTop: '10px' }}>
              <div className={`${style.noteBox__row__text} ${style.noteBox__row__textMain}`}>
                Total
              </div>
              <div className={`${style.noteBox__row__value} ${style.noteBox__row__valueMain}`}>
                $ {formatNum(Math.round([...dataChart[0].operandos, ...dataChart[1].operandos].reduce((acc, cur) => acc + cur.monto, 0)))}
              </div>
            </div>
          </div>
        )}
        {showTienes && (
          <div className={style.noteBox}>
          <div className={style.noteBox__close} onClick={closeBox}>x</div>
          <div className={style.noteBox__row}>
            <div className={`${style.noteBox__row__text} ${style.noteBox__row__text__bold}`}>
              {dataChart[2].operandos[0].caption}
            </div>
            <div className={`${style.noteBox__row__value} ${style.noteBox__row__value__bold}`}>
              $ {formatNum(Math.round(dataChart[2].operandos[0].monto))}
            </div>
          </div>
          <div className={style.noteBox__row}>
            <div className={`${style.noteBox__row__text} ${style.noteBox__row__text__bold}`}>
              - {dataChart[2].operandos[1].caption}
            </div>
            <div className={`${style.noteBox__row__value} ${style.noteBox__row__value__bold}`}>
              $ {formatNum(Math.round(dataChart[2].operandos[1].monto))}
            </div>
          </div>
          <div className={style.noteBox__row}>
            <div className={`${style.noteBox__row__text} ${style.noteBox__row__text__bold}`}>
              - {dataChart[2].operandos[2].caption}
            </div>
            <div className={`${style.noteBox__row__value} ${style.noteBox__row__value__bold}`}>
              $ {formatNum(Math.round(dataChart[2].operandos[2].monto))}
            </div>
          </div>
          <div className={style.separateLine} />
          <div className={style.noteBox__row}>
            <div className={`${style.noteBox__row__text} ${style.noteBox__row__text__semiBold}`}>
              {dataChart[2].operandos[3].caption}
            </div>
            <div className={`${style.noteBox__row__value} ${style.noteBox__row__value__bold}`}>
              $ {formatNum(Math.round(dataChart[2].operandos[3].monto))}
            </div>
          </div>
          <div className={style.noteBox__row} style={{ marginTop: '10px' }}>
            <div className={`${style.noteBox__row__text} ${style.noteBox__row__text__semiBold}`}>
              x años
            </div>
            <div className={`${style.noteBox__row__value} ${style.noteBox__row__value__bold}`}>
              {dataChart[2].anios} años
            </div>
          </div>
          <div className={style.noteBox__row} style={{ marginTop: '10px' }}>
            <div className={`${style.noteBox__row__text} ${style.noteBox__row__text__semiBold}`}>
              {dataChart[2].operandos[4].caption}
            </div>
            <div className={`${style.noteBox__row__value} ${style.noteBox__row__value__bold}`}>
              $ {formatNum(Math.round(dataChart[2].operandos[4].monto))}
            </div>
          </div>
        </div>
        )}
      </div>
    </div>
  )
}

export default DoughnutChart
